import { useState } from 'react';
import { Alert, Box, Button, InputAdornment, Modal, Snackbar, Typography } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';
import SaveIcon from '@mui/icons-material/Save';
import { fetchWrapper, SERVER } from '../../utils/helpers';
import { useAuth } from '../../contexts/AuthContext';
import CustomInput from '../Inputs/CustomInput';
import ErrorModal from './ErrorModal';

const UpdatePriceModal = ({ open, setOpen, product, setProduct }) => {
  const { theme } = useTheme();
  const { encodedAuth, user, password, isSubUser } = useAuth();

  const [loading, setLoading] = useState(false);

  const [openErrModal, setOpenErrModal] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage] = useState("");

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenMessage(false);
  };

  const handleUpdatePrice = async (sku, price) => {
    setLoading(true);
    const body = {
      sku: sku,
      price: price
    };
    try {
      const data = await fetchWrapper(`${SERVER}/post_update_bulk_prices`, user, password, encodedAuth, { method: 'POST', body: body });
      setMessage(data.feedId);
      setOpenMessage(true);
    } catch (error) {
      console.error('Error update price:', error.message);
      setErrMsg(error.message);
      setOpenErrModal(true);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const styles = {
    modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '26vw',
      bgcolor: theme.background.primary,
      borderRadius: 2,
      border: `4px solid ${theme.color.primary}`,
      boxShadow: 24,
      p: 4,
      outline: 'none',
    },
    button: {
      textTransform: 'none',
      fontFamily: theme.fontFamily,
      color: theme.text.negative,
      borderRadius: '20px',
      border: `1px solid ${theme.border.light}`,
      backgroundColor: theme.accent.success,
    }
  };

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={styles.modal}>
          <Typography variant="h6" component="h2" gutterBottom sx={{ fontFamily: theme.fontFamily, textAlign: 'center', color: theme.text.primary }}>
            Update price for: <br />{product.sku}.
          </Typography>

          <CustomInput
            fullWidth
            label={"Selling Price"}
            value={product.price}
            onChange={(e) => setProduct((prev) => { return { ...prev, price: parseFloat(e.target.value) } })}
            type="number"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography sx={{ color: theme.text.primary, fontFamily: theme.fontFamily }}>
                    $
                  </Typography>
                </InputAdornment>
              )
            }}
            inputProps={{
              min: 0,
              max: 1000000000000000,
              step: 0.01
            }}
          />

          {/* Cancel button */}
          <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 3 }}>
            <Button
              variant="contained"
              sx={styles.button}
              onClick={() => handleUpdatePrice(product.sku, product.price)}
              endIcon={<SaveIcon />}
              disabled={loading} // <-- disable when loading
            >
              {loading ? 'Saving...' : 'Save'}
            </Button>

          </Box>
        </Box>
      </Modal>

      <Snackbar open={openMessage} autoHideDuration={15000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          variant="filled"
          sx={{ width: '100%', fontFamily: theme.fontFamily, bgcolor: theme.accent.success }}
        >
          Update price feed ID: <Typography variant="body2" sx={{ fontFamily: theme.fontFamily, cursor: 'pointer' }} onClick={() => navigator.clipboard.writeText(message)}>{message}</Typography>
        </Alert>
      </Snackbar>

      <ErrorModal open={openErrModal} setOpen={setOpenErrModal} message={errMsg} />
    </>
  );
};

export default UpdatePriceModal;